<template>
  <div class="page-main">
    <img class="logo" src="~@/assets/logo_sbux.png" />

    <div class="card img" @click="toPage('home')">
      <img src="~@/assets/ic_pickup_group_order_bill_backgroud.png" />
    </div>
    <div class="row">
      <div class="card" @click="toPage('history')">
        <span class="title">历史订单</span>
        <img  class="icon" src="~@/assets/ic_time.png"/>
      </div>
      <div class="card" @click="toPage('code')">
        <span class="title">优惠券</span>
        <img class="icon" src="~@/assets/order_icon_coupons.png"/>
      </div>
    </div>
    
  
    <div class="page-address">
      <div class="left" @click="toShop">
        <div class="label">
          <img class="icon" src="~@/assets/ic_my_location.png" />
          <span>自取门店</span>
        </div>
        <div class="store-name text-ellipsis">{{ store.name }}</div>
        <div class="store-address text-ellipsis">{{ store.address }}</div>
      </div>
      <div class="right">
        <img src="~@/assets/qrcode.png" @click="toExternal"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  methods: {
    toPage(page) {
      this.$router.push({ name: page });
    },
    toExternal() {
      const { phone, sign } = this.$store.state;
      window.location.href = `http://152.136.208.177/?p=${phone}&s=${sign}`;
    },
    toShop() {
      this.$router.push({ name: "shop" });
    },
	
  },
  computed: {
    ...mapGetters({
      store: "getStore",
    }),
  },
};
</script>

<style lang="scss" scoped>
.page-main {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;

  .logo {
    width: 400px;
    display: block;
    margin: 100px auto 80px;
  }

  .row{
    flex: 1;
    display: flex;
    margin: 0 15px;

    &>.card{
      margin-left: 15px;
      margin-right: 15px;
    }
  }
}

.page-address {
  background: #333;
  color: #fff;
  padding: 30px;
  display: flex;
  align-items: center;

  .left {
    flex: 1;
  }

  .right {
    padding: 0 30px;
    img {
      display: block;
      width: 60px;
      height: 60px;
      opacity: 0.5;
    }
  }

  .label {
    display: flex;
    align-items: center;
    color: rgba(255, 255, 255, 0.7);
    margin-bottom: 10px;

    .icon {
      width: 26px;
      margin-right: 10px;
    }
  }

  .store-name {
    font-size: 30px;
    margin-bottom: 10px;
  }

  .store-address {
	inline-size: 500px; 
    font-size: 24px;
    transform: scale(0.83);
	transform-origin: left;
  }
}

.card {
  flex: 1;
  margin: 0 30px 30px 30px;
  padding: 30px;
  border-radius: 18px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  position: relative;

  .title{
    font-size: 30px;
  }

  .icon{
    position: absolute;
    bottom: 40px;
    right: 40px;
    width: 140px;
    height: 140px;
    object-fit: contain;
  }

  &.img {
    flex: 0;
    padding: 0;
    overflow: hidden;
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>